import axiosInstance from '@/api/axiosInstance';
import {
  UpdatePathRequest,
  LearningPathResponse,
} from '@/modules/learningCenter/features/LearningPaths/apiTypes';

/**
 * Update an existing learning path
 * PUT /api/learning-paths/:id
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 */
export const updateLearningPath = async (
  id: number,
  data: UpdatePathRequest
): Promise<LearningPathResponse> => {
  try {
    const response = await axiosInstance.put<{ data: LearningPathResponse['path'] }>(
      `/api/learning-paths/${id}`,
      data
    );

    // Backend wraps the flat path DTO in {data: ...}; reshape it like
    // createLearningPath does so callers can rely on `.path`.
    return {
      path: response.data.data,
      courses: [],
      milestones: [],
    };
  } catch (error) {
    console.error(`Error updating learning path ${id}:`, error);
    throw error;
  }
};
